module.exports = __webpack_public_path__ + "static/img/115.67e43186.png";